export default __webpack_public_path__ + "static/media/glass_white.9caf6252.svg";